/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import avatar1 from '../../assets/images/users/avatar-1.png';
import Timer from 'components/Timer';
import Badge from '@mui/material/Badge';
import axios from 'lib/axios';
import Button from '@mui/material/Button';
import { Box, IconButton } from '@mui/material';
import { Avatar } from '@mui/material';
import locationIcon from '../../assets/static_images/location.svg';
import ClockIcon from '../../assets/static_images/clock.svg';
import CalenderIcon from '../../assets/static_images/calander.svg';
import usersIcon from '../../assets/static_images/users.svg';
import { IoClose } from 'react-icons/io5';
import { getRoleLabel } from 'Helpers';

const EventDetails = ({ event, eventUsers, timeColor, setShowDetails, remainingTime, date, submitResponse, response }) => {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1300
            }}
        >
            <Box
                sx={{
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    width: '90%',
                    maxWidth: '600px',
                    maxHeight: '90vh',
                    overflow: 'hidden',
                    position: 'relative'
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '20px 24px',
                        borderBottom: '1px solid #e5e7eb'
                    }}
                >
                    <Typography
                        variant="h5"
                        sx={{
                            fontSize: '20px',
                            fontWeight: 600,
                            color: 'primary.main'
                        }}
                    >
                        Event Details
                    </Typography>
                    <IconButton
                        onClick={() => {
                            setShowDetails(false);
                        }}
                        sx={{
                            color: 'text.secondary',
                            bgcolor: 'grey.100',
                            borderRadius: '50%',
                            '&:hover': { bgcolor: 'grey.300' }
                        }}
                    >
                        <IoClose size={17} />
                    </IconButton>
                </Box>

                {/* Content */}
                <Box
                    sx={{
                        padding: '24px',
                        maxHeight: 'calc(90vh - 80px)',
                        overflow: 'auto'
                    }}
                >
                    {/* Timer Section */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginBottom: '32px'
                        }}
                    >
                        <Timer dateTime={date} />
                    </Box>

                    {/* Date and Time Section */}
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '24px',
                            marginBottom: '24px',
                            padding: '20px',
                            backgroundColor: '#f9fafb',
                            borderRadius: '12px',
                            border: '1px solid #e5e7eb'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '40px',
                                    height: '40px',
                                    backgroundColor: '#ffffff',
                                    borderRadius: '10px',
                                    border: '1px solid #e5e7eb'
                                }}
                            >
                                <img src={CalenderIcon} style={{ width: '18px', height: '18px' }} alt="calendar" />
                            </Box>
                            <Box>
                                <Typography
                                    sx={{
                                        fontSize: '13px',
                                        color: '#6b7280',
                                        fontWeight: 500,
                                        marginBottom: '4px'
                                    }}
                                >
                                    Date
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: '15px',
                                        fontWeight: 600,
                                        color: '#374151'
                                    }}
                                >
                                    {new Date(event.due_data).toString().substring(3, 16)}
                                </Typography>
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '40px',
                                    height: '40px',
                                    backgroundColor: '#ffffff',
                                    borderRadius: '10px',
                                    border: '1px solid #e5e7eb'
                                }}
                            >
                                <img src={ClockIcon} style={{ width: '18px', height: '18px' }} alt="clock" />
                            </Box>
                            <Box>
                                <Typography
                                    sx={{
                                        fontSize: '13px',
                                        color: '#6b7280',
                                        fontWeight: 500,
                                        marginBottom: '4px'
                                    }}
                                >
                                    Time
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: '15px',
                                        fontWeight: 600,
                                        color: '#374151'
                                    }}
                                >
                                    {`${
                                        parseInt(date.getHours()) > 12
                                            ? `${parseInt(date.getHours()) - 12 < 10 ? '0' : ''}${parseInt(date.getHours()) - 12}`
                                            : date.getHours()
                                    }:${date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()} ${
                                        parseInt(date.getHours()) > 12 ? 'PM' : 'AM'
                                    }`}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    {/* Venue Section */}
                    <Box sx={{ marginBottom: '24px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '40px',
                                    height: '40px',
                                    backgroundColor: '#f3f4f6',
                                    borderRadius: '10px'
                                }}
                            >
                                <img src={locationIcon} style={{ width: '18px', height: '18px' }} alt="location" />
                            </Box>
                            <Box>
                                <Typography
                                    sx={{
                                        fontSize: '13px',
                                        color: '#6b7280',
                                        fontWeight: 500,
                                        marginBottom: '4px'
                                    }}
                                >
                                    Venue
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: '15px',
                                        fontWeight: 600,
                                        color: '#374151'
                                    }}
                                >
                                    {event.venue}
                                </Typography>
                            </Box>
                        </Box>

                        {event?.venue_locaiton_map_link && (
                            <Box
                                sx={{
                                    padding: '12px 16px',
                                    backgroundColor: '#f9fafb',
                                    borderRadius: '8px',
                                    border: '1px solid #e5e7eb'
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: '13px',
                                        color: '#6b7280',
                                        fontWeight: 500,
                                        marginBottom: '4px'
                                    }}
                                >
                                    Map Link
                                </Typography>
                                <a
                                    href={event.venue_locaiton_map_link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        color: '#3b82f6',
                                        textDecoration: 'none',
                                        fontSize: '14px',
                                        fontWeight: 500
                                    }}
                                >
                                    View on Map
                                </a>
                            </Box>
                        )}
                    </Box>
                    {/* Organizers Section */}
                    <Box sx={{ marginBottom: '24px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '40px',
                                    height: '40px',
                                    backgroundColor: '#f3f4f6',
                                    borderRadius: '10px'
                                }}
                            >
                                <img src={usersIcon} style={{ width: '18px', height: '18px' }} alt="users" />
                            </Box>
                            <Typography
                                sx={{
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    color: '#374151'
                                }}
                            >
                                Organizers
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                maxHeight: '200px',
                                overflow: 'auto',
                                padding: '16px',
                                backgroundColor: '#f9fafb',
                                borderRadius: '12px',
                                border: '1px solid #e5e7eb'
                            }}
                        >
                            {eventUsers?.length > 0 ? (
                                eventUsers.map((user, index) => {
                                    if (user.is_organizer) {
                                        return (
                                            <Box
                                                key={`organizer-${index}-${user.user_id}`}
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '12px',
                                                    padding: '12px',
                                                    backgroundColor: '#ffffff',
                                                    borderRadius: '8px',
                                                    marginBottom: index < eventUsers.filter((u) => u.is_organizer).length - 1 ? '8px' : 0,
                                                    border: '1px solid #e5e7eb'
                                                }}
                                            >
                                                <Avatar
                                                    src={user.profile_image}
                                                    alt={user.first_name}
                                                    sx={{
                                                        width: 48,
                                                        height: 48
                                                    }}
                                                />
                                                <Box>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '15px',
                                                            fontWeight: 600,
                                                            color: '#374151',
                                                            marginBottom: '2px'
                                                        }}
                                                    >
                                                        {user.first_name} {user.last_name}
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '13px',
                                                            color: '#6b7280'
                                                        }}
                                                    >
                                                        {getRoleLabel(user.role?.role_type)}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        );
                                    }
                                    return null;
                                })
                            ) : (
                                <Typography
                                    sx={{
                                        fontSize: '14px',
                                        color: '#6b7280',
                                        textAlign: 'center',
                                        padding: '20px'
                                    }}
                                >
                                    No organizers found
                                </Typography>
                            )}
                        </Box>
                    </Box>
                    {/* Action Buttons */}
                    {remainingTime > 0 && response === 'maybe' ? (
                        <Box sx={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => submitResponse('yes')}
                                sx={{
                                    backgroundColor: '#10b981',
                                    color: '#ffffff',
                                    textTransform: 'none',
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    padding: '12px 24px',
                                    borderRadius: '10px',
                                    '&:hover': {
                                        backgroundColor: '#059669'
                                    }
                                }}
                            >
                                Attend
                            </Button>
                            <Button
                                fullWidth
                                variant="outlined"
                                onClick={() => submitResponse('no')}
                                sx={{
                                    borderColor: '#d1d5db',
                                    color: '#6b7280',
                                    textTransform: 'none',
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    padding: '12px 24px',
                                    borderRadius: '10px',
                                    '&:hover': {
                                        borderColor: '#9ca3af',
                                        backgroundColor: '#f9fafb'
                                    }
                                }}
                            >
                                Decline
                            </Button>
                        </Box>
                    ) : (
                        <Box sx={{ marginTop: '24px' }}>
                            <Button
                                fullWidth
                                variant="outlined"
                                onClick={() => setShowDetails(false)}
                                sx={{
                                    borderColor: '#d1d5db',
                                    color: '#6b7280',
                                    textTransform: 'none',
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    padding: '12px 24px',
                                    borderRadius: '10px',
                                    '&:hover': {
                                        borderColor: '#9ca3af',
                                        backgroundColor: '#f9fafb'
                                    }
                                }}
                            >
                                Close
                            </Button>
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default EventDetails;
